import React from "react";
import { Routes, Route } from "react-router-dom";

import PortalLanding from "./Pages/LandingPage/LandingPage";
import PatientLogin from "./Components/Auth/PatientLogin";
import RequestAppointment from "./Components/Patient/Appointment/RequestAppointment";
import PatientDashboard from "./Pages/Patient/Dashboard";
import MyAppointmentsPage from "./Pages/Patient/MyAppointments";

import StaffLogin from "./Components/Auth/StaffLogin";

import ReceptionistDashboard from "./Pages/Receptionist/Dashboard";
import ReceptionistAppointments from "./Pages/Receptionist/Appointments";
import ReceptionistReports from "./Pages/Receptionist/Report";
import ReceptionistBilling from "./Pages/Receptionist/Billing";
import ReceptionistInsurance from "./Pages/Receptionist/Insurance";
import ReceptionistProfile from "./Pages/Receptionist/Profile";
import ReceptionConsultation from "./Pages/Receptionist/Consultation";

import DoctorDashboard from "./Pages/Doctor/Dashboard";
import DoctorMyAppointments from "./Pages/Doctor/MyAppointments";
import DoctorReports from "./Pages/Doctor/Report";
import DoctorProfile from "./Pages/Doctor/Profile";
import DoctorConsultation from "./Pages/Doctor/Consultation";
import DoctorAvailabilityScreen from "./Pages/Admin/DoctorSlots";

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<StaffLogin />} />

      {/* Patient */}
      <Route path="/patient-login" element={<PortalLanding />} />
      <Route path="/patient-auth" element={<PatientLogin />} />
      <Route path="/request-appointment" element={<RequestAppointment />} />
      <Route path="/patient-dashboard" element={<PatientDashboard />} />
      <Route path="/my-appointments" element={<MyAppointmentsPage />} />

      {/* Receptionist */}
      <Route path="/receptionist/dashboard" element={<ReceptionistDashboard />} />
      <Route path="/receptionist/appointments" element={<ReceptionistAppointments />} />
      <Route path="/receptionist/reports" element={<ReceptionistReports />} />
      <Route path="/receptionist/billing" element={<ReceptionistBilling />} />
      <Route path="/receptionist/insurance" element={<ReceptionistInsurance />} />
      <Route path="/receptionist/profile" element={<ReceptionistProfile />} />
      <Route path="/reception/consultation/:appointmentId" element={<ReceptionConsultation />} />

      {/* Doctor */}
      <Route path="/doctor/dashboard" element={<DoctorDashboard />} />
      <Route path="/doctor/appointments" element={<DoctorMyAppointments />} />
      <Route path="/doctor/reports" element={<DoctorReports />} />
      <Route path="/doctor/profile" element={<DoctorProfile />} />
      <Route path="/doctor/consultation/:appointmentId" element={<DoctorConsultation />} />

      {/* Admin */}
      <Route path="/admin/docotrslots" element={<DoctorAvailabilityScreen />} />

    </Routes>
  );
}